// extracted by mini-css-extract-plugin
export var issueIcon = "index-module--issueIcon--lg9WX";
export var issueItem = "index-module--issueItem--luJg0";
export var issueList = "index-module--issueList--BiAid";
export var issueTitle = "index-module--issueTitle--6fQBg";
export var issuesContainer = "index-module--issuesContainer--jFmvL";
export var issuesIconTitle = "index-module--issuesIconTitle--u1xb6";